import React from "react";
import {
  BarChart,
  LineChart,
  Line,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";
import { Calendar, Star, Users, TrendingUp, CalendarDays ,PackageCheck, } from "lucide-react";
import { useNavigate } from "react-router-dom";
const salesData = [
  {
    day: "Mon",
    value: 3000,
  },
  {
    day: "Tue",
    value: 4000,
  },
  {
    day: "Wed",
    value: 3500,
  },
  {
    day: "Thu",
    value: 5000,
  },
  {
    day: "Fri",
    value: 4500,
  },
  {
    day: "Sat",
    value: 6000,
  },
  {
    day: "Sun",
    value: 3000,
  },
];
const appointmentData = [
  {
    day: "Mon",
    count: 1.2,
  },
  {
    day: "Tue",
    count: 1.8,
  },
  {
    day: "Wed",
    count: 1.5,
  },
  {
    day: "Thu",
    count: 2.0,
  },
  {
    day: "Fri",
    count: 1.8,
  },
  {
    day: "Sat",
    count: 2.2,
  },
  {
    day: "Sun",
    count: 1.0,
  },
];

const appointments = [
  {
    name: "Priya Sharma",
    type: "Yoga Session",
    time: "2:00 PM",
    amount: "₹800",
    image:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3",
  },
  {
    name: "Rahul Mehta",
    type: "Personal Training",
    time: "3:30 PM",
    amount: "₹1,200",
    image:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3",
  },
  {
    name: "Sarah Johnson",
    type: "Meditation Class",
    time: "4:45 PM",
    amount: "₹600",
    image:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3",
  },
];

const deals = [
  {
    name: "Summer Wellness Package",
    progress: 75,
    sales: 45,
    price: "₹8,550",
    expiresIn: "3 days",
    image:
      "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?ixlib=rb-4.0.3",
  },
  {
    name: "Beginner's Yoga Bundle",
    progress: 60,
    sales: 32,
    price: "₹5,280",
    expiresIn: "5 days",
    image:
      "https://images.unsplash.com/photo-1603988363607-e1e4a66962c6?ixlib=rb-4.0.3",
  },
  {
    name: "Premium Meditation Course",
    progress: 45,
    sales: 28,
    price: "₹4,200",
    expiresIn: "7 days",
    image:
      "https://images.unsplash.com/photo-1506126613408-eca07ce68773?ixlib=rb-4.0.3",
  },
];

const activities = [
  {
    id: 1,
    icon: <CalendarDays className="w-5 h-5 text-blue-600" />,
    iconBg: "bg-blue-100",
    description: "New appointment request from Sarah Johnson",
    time: "10 minutes ago",
  },
  {
    id: 2,
    icon: <PackageCheck className="w-5 h-5 text-green-600" />,
    iconBg: "bg-green-100",
    description: "Summer Wellness Package purchased by Rahul Mehta",
    time: "25 minutes ago",
  },
  {
    id: 3,
    icon: <Star className="w-5 h-5 text-yellow-500" />,
    iconBg: "bg-yellow-100",
    description: "New 5-star review from Priya Sharma",
    time: "1 hour ago",
    highlight: true,
  },
];


const StatsCard = ({ icon: Icon, value, label, trend }) => (
  <div className="bg-white p-4 rounded-lg shadow-sm">
    <div className="flex items-center justify-between">
      <div>
        <p className="text-2xl font-semibold">{value}</p>
        <p className="text-gray-500 text-sm">{label}</p>
      </div>
      <Icon className="text-gray-400 w-6 h-6" />
    </div>
    <p
      className={`text-xs mt-2 ${
        trend > 0 ? "text-green-500" : "text-red-500"
      }`}
    >
      {trend > 0 ? "+" : ""}
      {trend}% vs last month
    </p>
  </div>
);
const VendorHomePageDashboard = (dataId) => {

  const navigate = useNavigate()
  
  return (
    <div className="min-h-screen bg-gray-50 p-6" data-id={dataId}>
      <div className="max-w-7xl mx-auto">
        <header className="flex justify-between items-center mb-8">
          <div>
            <h1 className="text-2xl font-bold">Welcome Back!</h1>
            <p className="text-gray-500">
              Here's what's happening with your business today
            </p>
          </div>
          <div className="flex gap-3">
            <button className="px-4 py-2 border rounded-lg hover:bg-gray-50">
              Schedule
            </button>
            <button  onClick={()=>navigate(`/vendor/deal/add`)}  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">
              Create New Deal
            </button>
          </div>
        </header>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8">
          <StatsCard
            icon={TrendingUp}
            value="$45,289"
            label="Total Sales"
            trend={2.4}
          />
          <StatsCard
            icon={Users}
            value="1.2k"
            label="Total Customers"
            trend={-1.5}
          />
          <StatsCard
            icon={Star}
            value="4.8"
            label="Average Rating"
            trend={0.8}
          />
          <StatsCard
            icon={Calendar}
            value="8"
            label="Active Deals"
            trend={3.2}
          />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <div className="bg-white p-4 rounded-lg shadow-sm">
            <div className="flex justify-between items-center mb-4">
              <h2 className="font-semibold">Sales Overview</h2>
              <select className="border rounded-md px-2 py-1 text-sm">
                <option>Last 7 days</option>
              </select>
            </div>
            <LineChart width={500} height={300} data={salesData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="day" />
              <YAxis />
              <Tooltip />
              <Line type="monotone" dataKey="value" stroke="#ff7c43" />
            </LineChart>
          </div>
          <div className="bg-white p-4 rounded-lg shadow-sm">
            <div className="flex justify-between items-center mb-4">
              <h2 className="font-semibold">Appointment Analytics</h2>
              <select className="border rounded-md px-2 py-1 text-sm">
                <option>Last 7 days</option>
              </select>
            </div>
            <BarChart width={500} height={300} data={appointmentData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="day" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="count" fill="#ff7c43" />
            </BarChart>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-white p-4 rounded-lg shadow-sm">
            <div className="flex justify-between items-center mb-4">
              <h2 className="font-semibold">Pending Appointments</h2>
              <a href="#" className="text-blue-600 text-sm">
                View All
              </a>
            </div>
            {/* Appointments list */}
            <div className="space-y-4">
              {appointments.map((appointment, i) => (
                <div
                  key={i}
                  className="flex items-center justify-between bg-white p-4 rounded-xl shadow-sm"
                >
                  <div className="flex items-center gap-4">
                    <img
                      src={appointment.image}
                      alt={appointment.name}
                      className="w-14 h-14 rounded-full object-cover"
                    />
                    <div>
                      <p className="text-base font-semibold text-gray-900">
                        {appointment.name}
                      </p>
                      <p className="text-sm text-gray-600">
                        {appointment.type}
                      </p>
                      <div className="flex items-center text-sm text-gray-500 mt-1">
                        <CalendarDays className="w-4 h-4 mr-1" />
                        <span>Today, {appointment.time}</span>
                      </div>
                    </div>
                  </div>
                  <div className="text-right space-y-2">
                    <p className="text-lg font-semibold text-gray-900">
                      {appointment.amount}
                    </p>
                    <div className="flex gap-2 justify-end">
                      <button className="bg-green-500 hover:bg-green-600 text-white text-sm px-3 py-1 rounded-md">
                        Accept
                      </button>
                      <button className="bg-red-500 hover:bg-red-600 text-white text-sm px-3 py-1 rounded-md">
                        Decline
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="bg-white p-4 rounded-lg shadow-sm">
            <div className="flex justify-between items-center mb-4">
              <h2 className="font-semibold">Active Deals</h2>
              <a href="#" className="text-blue-600 text-sm">
                View All
              </a>
            </div>
            {/* Deals list */}
            <div className="space-y-4">
              {deals?.map((deal, i) => (
                <div
                  key={i}
                  className="bg-white p-4 rounded-xl shadow-sm flex gap-4 items-center"
                >
                  <img
                    src={deal.image}
                    alt={deal.name}
                    className="w-16 h-16 rounded-lg object-cover"
                  />
                  <div className="flex-1">
                    <div className="flex justify-between items-start">
                      <h3 className="font-semibold text-gray-900">
                        {deal.name}
                      </h3>
                      <span className="text-sm text-orange-500">
                        Expires in {deal.expiresIn}
                      </span>
                    </div>
                    <div className="flex text-sm text-gray-600 mt-1 gap-4">
                      <span>{deal.sales} sales</span>
                      <span>{deal.price}</span>
                    </div>
                    <div className="mt-2">
                      <div className="w-full bg-gray-200 rounded-full h-2">
                        <div
                          className="bg-orange-500 h-2 rounded-full"
                          style={{ width: `${deal.progress}%` }}
                        />
                      </div>
                      <div className="text-sm text-gray-600 text-right mt-1">
                        {deal.progress}%
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
        </div>
        <div className="bg-white p-6 rounded-xl shadow-sm">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-semibold text-gray-800">Recent Activity</h2>
        <a href="#" className="text-sm text-orange-500 hover:underline">
          View All
        </a>
      </div>
      <div className="space-y-4">
        {activities.map((item) => (
          <div
            key={item.id}
            className={`flex items-start gap-3 p-3 rounded-lg ${
              item.highlight ? "bg-gray-50" : ""
            }`}
          >
            <div
              className={`rounded-md p-2 ${item.iconBg} flex items-center justify-center`}
            >
              {item.icon}
            </div>
            <div>
              <p className="text-sm text-gray-800">{item.description}</p>
              <p className="text-xs text-gray-500 mt-0.5">{item.time}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
      </div>
    </div>
  );
};

export default VendorHomePageDashboard;
